import { supabase } from '../lib/supabase';
import { normalizeCrmStudioSettings } from '../config/crmStudio';

/**
 * @typedef {{
 *   baseUrl: string,
 *   isEnabled: boolean,
 *   allowedRoleTypes: string[],
 *   allowedPhaseKeys: string[],
 * }} CrmStudioSettings
 */

function mapRow(row) {
  if (!row) return null;
  return normalizeCrmStudioSettings({
    base_url: row.base_url,
    is_enabled: row.is_enabled,
    allowed_role_types: row.allowed_role_types,
    allowed_phase_keys: row.allowed_phase_keys,
  });
}

export async function fetchCrmStudioSettings() {
  const { data, error } = await supabase
    .from('crm_studio_settings')
    .select('base_url, is_enabled, allowed_role_types, allowed_phase_keys')
    .eq('singleton_key', 'default')
    .maybeSingle();

  if (error) throw error;
  return mapRow(data) ?? normalizeCrmStudioSettings(null);
}

/**
 * @param {CrmStudioSettings} payload
 */
export async function saveCrmStudioSettings(payload) {
  const {
    data: { user },
  } = await supabase.auth.getUser();

  const baseUrl = String(payload?.baseUrl ?? '')
    .trim()
    .replace(/\/+$/, '');

  const row = {
    singleton_key: 'default',
    base_url: baseUrl,
    is_enabled: payload?.isEnabled !== false,
    allowed_role_types: Array.isArray(payload?.allowedRoleTypes)
      ? payload.allowedRoleTypes.filter(Boolean)
      : [],
    allowed_phase_keys: Array.isArray(payload?.allowedPhaseKeys)
      ? payload.allowedPhaseKeys.filter(Boolean)
      : [],
    updated_at: new Date().toISOString(),
    updated_by: user?.id ?? null,
  };

  const { data, error } = await supabase
    .from('crm_studio_settings')
    .upsert(row, { onConflict: 'singleton_key' })
    .select('base_url, is_enabled, allowed_role_types, allowed_phase_keys')
    .single();

  if (error) throw error;
  return mapRow(data) ?? normalizeCrmStudioSettings(null);
}
